export const initHelpForm = () => {
	var _fo = window._fo ? window._fo : [];

	_fo.push({
		c: 'opcwr',
		i: 'emquxfc',
		m: 1,
		s: 0,
		w: 1320,
	});
	window._fo = _fo;

	if (typeof fce == 'undefined') {
		var s = document.createElement('script');
		s.type = 'text/javascript';
		s.async = true;
		s.src = 'https://formcrafts.com/js/fc.js';
		document.body.appendChild(s);
		window.fce = 1;
	}
};
